import { createSvgIcon } from './createSvgIcon'

export default createSvgIcon(
  <>
    <path d="M6 19h4V5H6zm8-14v14h4V5z"></path>
  </>,
  'Pause',
)
